<template lang="pug">
.option-target-other-user-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    // セル：施設関係者グループ
    template(#cell(groupName)="row")
      span {{ row.item.name }}（{{ row.item.groupTypeName }}）
    // セル：施設関係者メンバー
    template(#cell(memberName)="row")
      span {{ row.item.memberName }}（{{ row.item.memberOrganization }}）
    // セル：同意の返信日時
    template(#cell(datetime)="row")
      span(v-if="row.item.datetime != null") {{ convertDateText(row.item.datetime) }}
    // セル：返信時の連絡事項
    template(#cell(message)="row")
      span {{ row.item.message }}
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { SenderType } from "@/commons/models/OtherUserGroup";

/**
 * ### 文書送付、確認・同意ユーザー一覧テーブル
 */
@Component({})
export default class OptionTargetOtherUserTable extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<OptionTargetOtherUserTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<OptionTargetOtherUserTableField>;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): Array<OptionTargetOtherUserTableItem> {
    return this.value;
  }

  public convertDateText(datetime: number): string {
    const date: string = this.$dateUtil.convertNumberToString(datetime, "yyyy年mm月dd日 hh:MM");
    return date;
  }
}

/** テーブルの列名の情報 */
export interface OptionTargetOtherUserTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface OptionTargetOtherUserTableItem {
  /** 施設関係者グループソートキー */
  otherUserGroupsSortKey: string;
  /** グループを一意に識別する ID */
  id: number;
  /** グループ名 */
  name: string;
  /** グループの種類の ID。otherUserGroupTypes の id とひもづく */
  groupTypeId: number;
  /** グループ種類名 */
  groupTypeName: string;
  /** 送信種別 */
  senderType: SenderType;
  /** グループ内のメンバーを一意に識別する ID */
  memberId: number;
  /** メンバー名 */
  memberName: string;
  /** メンバー電話番号 */
  memberTel: string;
  /** メンバー所属 */
  memberOrganization: string;
  /** メンバーのLINE の ID */
  memberLineId: string | null;
  /** メンバーのメールアドレス */
  memberMailaddress: string | null;
  /** 返信日時 */
  datetime: number | null;
  /** 返信内容 */
  message: string;
  /** 格納元情報 */
  source: any;

  /** 再送対象かどうか */
  isTarget: boolean;
  /** 再送確認モーダルのkey */
  key: string;
  /** 再送確認モーダルの表示名 */
  displayName: string;
}
</script>
